module.exports = __webpack_public_path__ + "static/media/palmTreeDying.b707947f.png";